import React, {useEffect, useState} from "react"
import classNames from "classnames"
import { showElemFullyInScrollContainer } from "../../../utils/showElemFullyInScrollContainer"

import AdaptiveWrapText from "../AdaptiveWrapText"
import AdaptiveLink from "../AdaptiveLink"
import ChevronRight from "../../../assets/_V2/svg/ChevronRight"

import { PageLinkItem } from "../../../pages-data/_V2/common/links"
import styles from "./styles.module.scss"

export enum SOLID_TABS_THEMES {
	DEFAULT = "DEFAULT",
	GREEN_LIGHT = "GREEN_LIGHT",
	CYAN = "CYAN",
	ORANGE = "ORANGE",
	PURPLE_LIGHT = "PURPLE_LIGHT"
}
export interface SolidTabsItem {
	tabName: string
	desktopTitle: string
	mobileTitle?: string
	tabletTitle?: string
	desktopContent: JSX.Element | string
	tabletContent?: JSX.Element | string
	mobileContent?: JSX.Element | string
	detailLink?: PageLinkItem
	detailText?: string
	mediaContent: JSX.Element
	backdropContent: JSX.Element
	titleClass?: string
}
export interface SolidTabsProps {
	items: SolidTabsItem[]
	theme?: SOLID_TABS_THEMES
	transformOnAdaptive?: boolean
	className?: string
}

export default function SolidTabs(props: SolidTabsProps) {
	const items = props.items
	const theme = props.theme || SOLID_TABS_THEMES.DEFAULT
	const isGreenLightTheme = theme === SOLID_TABS_THEMES.GREEN_LIGHT
	const isCyanTheme = theme === SOLID_TABS_THEMES.CYAN
	const isOrangeTheme = theme === SOLID_TABS_THEMES.ORANGE
	const isPurpleLightTheme = theme === SOLID_TABS_THEMES.PURPLE_LIGHT
	const isTransformOnAdaptive = props.transformOnAdaptive || false

	const [selectedItem, setSelectedItem] = useState(items && items[0])

	useEffect(() => {
		setSelectedItem(props.items[0]);
	}, [props.items])

	const setItemPosition = (itemData, evt) => {
		showElemFullyInScrollContainer(
			evt.currentTarget,
			evt.currentTarget.parentNode
		)

		setSelectedItem(itemData)
	}

	const renderTabList = (): JSX.Element => (
		<ul className={styles.tabsList}>
			{items.map(item => (
				<li
					key={item.tabName}
					className={classNames(styles.tab, {
						[styles.__selected]: item === selectedItem,
					})}
					onClick={e => {
						setItemPosition(item, e)
					}}
				>
					{item.tabName}
				</li>
			))}
		</ul>
	)

	return (
		<section className={classNames(styles.section, props.className)}>
			<div
				className={classNames(styles.items, {
					[styles.items_theme_green_light]: isGreenLightTheme,
					[styles.items_theme_cyan]: isCyanTheme,
					[styles.items_theme_orange]: isOrangeTheme,
					[styles.items_theme_purple_light]: isPurpleLightTheme,
					[styles.items_transform_on_adaptive]: isTransformOnAdaptive,
				})}
			>
				<div className={styles.itemContainer}>
					{selectedItem.backdropContent}
					<div className={styles.tabListSection}>{renderTabList()}</div>

					{items.map(item => (
						<div key={item.tabName} className={styles.textSection}>
							<div
								className={classNames(styles.itemContentContainer, {
									[styles.__selected]: item.tabName === selectedItem.tabName,
								})}
								key={item.tabName}
							>
								{/* <h2 className={styles.title}>
                                    <AdaptiveWrapText
                                        desktop={item.desktopTitle}
                                        tablet={item.tabletTitle}
                                        mobile={item.mobileTitle}
                                    />
                                </h2>

                                <AdaptiveWrapText
                                    className={styles.description}
                                    desktop={item.desktopContent}
                                    tablet={item.tabletContent}
                                    mobile={item.mobileContent}
                                /> */}

								<AdaptiveWrapText
									desktop={item.desktopTitle}
									tablet={item.tabletTitle}
									mobile={item.mobileTitle}
									noBreakWordsMobile
									titleClasses={classNames(styles.title, item?.titleClass)}
								>
									<h2>{item.desktopTitle}</h2>
								</AdaptiveWrapText>

								<AdaptiveWrapText
									className={styles.description}
									desktop={item.desktopContent}
									tablet={item.tabletContent}
									mobile={item.mobileContent}
								>
									<span>{item.desktopContent}</span>
								</AdaptiveWrapText>
							</div>
						</div>
					))}
					{items.map(item => (
						<div
							key={item.tabName + "mediaContent"}
							className={styles.mediaSection}
						>
							<div
								className={classNames(styles.itemMediaContainer, {
									[styles.__selected]: item.tabName === selectedItem.tabName,
								})}
							>
								{item.mediaContent}
							</div>
						</div>
					))}
				</div>

				{selectedItem.detailLink && (
					<div className={styles.itemFooter}>
						<AdaptiveLink
							className={styles.actionLink}
							href={selectedItem.detailLink.href}
							useGatsbyLink={selectedItem.detailLink.useGatsbyLink}
						>
							<>
								{selectedItem.detailText ||
									selectedItem.detailLink.text ||
									"Подробнее"}
								<ChevronRight />
							</>
						</AdaptiveLink>
					</div>
				)}
			</div>
		</section>
	)
}
